import { TraceService, createErrorHandler } from '@sentry/angular';

import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { Router } from '@angular/router';

/**
 * @ngdoc module
 * @name ApSentryModule
 */
@NgModule({
    providers: [
        {
            provide: ErrorHandler,
            useValue: createErrorHandler()
        },
        {
            provide: TraceService,
            deps: [Router]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [TraceService],
            multi: true
        }
    ]
})
export class ApSentryModule {}
